import {
  LoanStatus,
  LoanStatusExternal,
  LoanStatusView,
  OrderStatusView,
  SinglePaymentStatus,
} from '@nemuru-eng/js-api-client';

import { Milestone } from '@/components/modules/Funnel/types/Milestone';

export enum ProgressStepStatus {
  COMPLETED = 'completed',
  FUTURE = 'future',
  PENDING = 'pending',
  CANCELLED = 'cancelled',
  DENIED = 'denied',
}

export type ProgressStep = {
  nameTextId: string;
  status: LoanStatus | LoanStatusExternal | SinglePaymentStatus;
  isMainStep: boolean;
  checkpointGroup: number;
  isHidden?: boolean;
};

export type LoanStatusViewStatus = LoanStatusView['statuses'][0];
export type OrderStatusViewStatus = OrderStatusView['statuses'][0];
export type SinglePaymentStatusViewStatus = {
  status: SinglePaymentStatus;
  updatedAt: Date;
  detail: string | null;
};
export type StatusView = LoanStatusViewStatus | OrderStatusViewStatus | SinglePaymentStatusViewStatus;

export type MilestoneProgressStages = Record<Milestone, ProgressStep[]>;
export type LoanStatusProgressStages = Partial<Record<LoanStatus, ProgressStep[]>>;
export type LoanStatusExternalProgressStages = Partial<Record<LoanStatusExternal, ProgressStep[]>>;
export type SinglePaymentStatusProgressStages = Partial<Record<SinglePaymentStatus, ProgressStep[]>>;
export type NonActiveProgressStages =
  | LoanStatusProgressStages
  | LoanStatusExternalProgressStages
  | SinglePaymentStatusProgressStages;

export type Status = LoanStatus | LoanStatusExternal | SinglePaymentStatus;
